import { Stack } from '@mui/material'

import useIsPartner from '~/features/partners/hooks/useIsPartner'
import AccountMenu from '~/layouts/app/header/account/portal/accountMenu'
import HelpMenu from '~/layouts/app/header/account/portal/helpMenu'
import SelectAgent from '~/layouts/app/header/account/portal/selectAgent'
import EEnvironmentVariables from '~/models/config'

function PortalAccount() {
  const isPartner = useIsPartner()

  return (
    <Stack sx={{ flexDirection: 'row', gap: 0, alignItems: 'center' }}>
      {import.meta.env[EEnvironmentVariables.VITE_IS_MULTIAGENT_ENABLED] ===
        'true' && <SelectAgent />}
      {!isPartner && <HelpMenu />}
      <AccountMenu />
    </Stack>
  )
}

export default PortalAccount
